import { useEffect, useState } from 'react';

/**
 * Retourne `value` après `delayMs` ms d'inactivité.
 * Utile pour ne pas spammer une API à chaque keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
